
import React from "react";
import { Loader } from "lucide-react";

export const LoadingState = () => (
  <div className="bg-white rounded-2xl shadow-xl border border-slate-200 text-center py-16 px-8">
    <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl mb-6 shadow-lg">
      <Loader className="w-10 h-10 text-white animate-spin" />
    </div>
    <h2 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
      Loading Projects...
    </h2>
    <p className="text-lg text-slate-600">Please wait while we fetch your data</p>
  </div>
);